// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import {
  UserServiceRequest,
  UserServiceRequest_Accept_Result,
} from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useAcceptUserServiceRequest: () => UseMutationResult<
  UserServiceRequest_Accept_Result,
  string,
  { userServiceRequestCid: ContractId<UserServiceRequest> }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { dso } = useParties();

  return useMutation({
    mutationKey: ['acceptuserServiceRequest', ledgerApi, dso],
    mutationFn: async ({ userServiceRequestCid }) => {
      return ledgerApi.acceptCredentialUserServiceRequest(userServiceRequestCid, dso);
    },
  });
};

export default useAcceptUserServiceRequest;
